const particlesParams = {
  interactivity: {
    events: {
      onHover: {
        enable: true,
        mode: 'attract',
      },
    },
    modes: {
      attract: {
        distance: 100,
        duration: 1,
        speed: 0.3,
      },
    },
  },
  particles: {
    number: {
      density: {
        enable: true,
        area: 800,
        factor: 800,
      },
      limit: 0,
      value: 100,
    },
    move: {
      speed: 0.5,
    },
    links: {
      opacity: 0.5,
    },
  },
};

export default particlesParams;